import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  getFolder (params) {
    return request.get(API.ADMIN_ITEMS, params)
  },
  detailFolder (params) {
    return request.get(API.ADMIN_FOLDER_DETAIL + params.id, params)
  },
  addFolder (params) {
    return request.post(API.ADMIN_FOLDER, params)
  },
  updateFolder (params) {
    return request.put(API.ADMIN_FOLDER_DETAIL + params.id, params)
  },
  deleteFolder (params) {
    return request.delete(API.ADMIN_FOLDER_DETAIL + params.id, params)
  },
  addFile (params) {
    return request.post(API.ADMIN_FILE, params)
  },
  checkUpload (params) {
    return request.get(API.ADMIN_FILE_CHECK_UPLOAD + params, params)
  },
  uploadChunk (params) {
    return request.post(API.ADMIN_FILE_CHUNK, params)
  },
  detailFile (params) {
    return request.get(API.ADMIN_FILE_DETAIL + params.id)
  },
  logFile (params) {
    const data = {...params, id: undefined}
    return request.get(API.ADMIN_FILE_DETAIL + params.id + '/logs', data)
  },
  updateFile (params, id) {
    return request.post(API.ADMIN_FILE_DETAIL + id + '/update_file', params)
  },
  deleteFile (params) {
    return request.delete(API.ADMIN_FILE_DETAIL + params.id)
  },
  copyFile (params) {
    return request.post(API.ADMIN_FILE_DETAIL + params.id)
  },
  getTag (params) {
    return request.get(API.ADMIN_GET_TAG, params)
  },
  getAuthor (params) {
    return request.get(API.ADMIN_AUTHOR, params)
  },
  getFolderSearch (params) {
    return request.get(API.MANAGER_FOLDER, params)
  },
  searchFile (params) {
    return request.get(API.ADMIN_FILE, params)
  },
  getShowBranches (params) {
    return request.get(API.ADMIN_FOLDER_DETAIL + params.id + '/branches', params)
  },
  getVideos (params) {
    return request.get(API.MANAGE_VIDEOS, params)
  },
  mergeVideos (params) {
    return request.post(API.MANAGE_VIDEOS, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/admin/folder.js